<div class="row col-12 p-0 m-0 main-page-section ">
  <!-- <div class="p-0">
            <app-side-nav [item]="meetingNav"></app-side-nav>
        </div> -->
  <div class="col-12 p-0 bulk-upload-preview">
    <!-- <app-header></app-header> -->
    <div class="col-height">

      <div>
        <div class="breadcrumbs-section padding-left">
          <span class="prev-page pr-2 prev" routerLink="/overview">Home</span>
          <img src="../../assets/images/seperator.png">
          <span class="prev-page pr-2 pl-2 prev" routerLink="/vms/bulk-invite">Invite</span>
          <img src="../../assets/images/seperator.png">
          <span class="prev-page pr-2 pl-2 prev" routerLink="/vms/bulk-invite/invite">Bulk Invite</span>
          <img src="../../assets/images/seperator.png">
          <span class="curr-page pl-2 breadcrumbs-section-font current">Preview</span>
        </div>

        <div class="invite-layout">
          <div class="row">
            <div class="col-9">
              <h1>Bulk Invite</h1>
            </div>
            <div class="col-3 upload-btn-wrapper">
              <button type="submit">Re-upload Excel Sheet here</button>
              <input type="file"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                name="myfile" (change)="bulkInvite($event)" />
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <h2 class="mt-4">Host Details</h2>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-4">
              <div class="dropdown-border pointer-link" style="position: relative;">
                <div (clickOutside)="onClickedOutside($event)" [autoClose]="'outside'" [ngbPopover]="popContentFullName"
                  triggers="manual" #pn="ngbPopover" (click)="openPopover(pn)" placement="bottom"
                  popoverClass='dash-popover dashboard-popover'>
                  <input class="pt-3 pb-3 pl-4 textbox-style placeholder-text pointer-link" readonly
                    [(ngModel)]="fullname" required>
                  <label class="form-lable-dropdown">Full Name</label>
                  <img src="../../../assets/images/Path.png" class="dropdown-icon" loading="lazy" />
                </div>
              </div>

              <ng-template #popContentFullName>
                <div class="dashboard-popover">
                  <div class="d-flex justify-content-between">
                    <div class="pl-3 pt-3 pr-3 pb-3 ">
                      <div class="row pb-2" *ngFor="let item of myCompanyData;let index =i"
                        (click)="setFullName(item); openPopover(pn);">
                        <div class="popover-content normal-font pl-3 email-width">
                          {{item.name}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>

            <div class="col-4">
              <div class="textbox-style">{{mobileNumber}}</div>
              <label class="form-lable">Mobile Number</label>
            </div>

            <div class="col-4">
              <div class="textbox-style">{{emailId}}</div>
              <label class="form-lable">Email-ID</label>
            </div>
          </div>

          <form #myForm=ngForm validate>
            <div class="row additionalMark mt-5">
              <div class="col-12">
                <p>Additional Remark<span>(Optional)</span></p>
              </div>
            </div>
            <div class="row additionalMark">
              <div class="col-12">
                <input type="text" [(ngModel)]="remarks">
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <h2 class="mt-4">Meeting Details</h2>
              </div>
            </div>

            <div class="row mt-3">

              <div class="col-2">
                <div class="date-container">
                  <input class="cal-icon textbox-style pointer-link pl-5" autocomplete="off" (click)="d1.toggle()"
                    (keypress)="$event.preventDefault()" (dateSelect)="updateSelectedDate($event)" id="owner-dob"
                    type="text" name="dp1" ngbDatepicker #d1="ngbDatepicker" readonly placeholder="Date">
                  <span>{{formatDate}}</span>
                </div>
              </div>

              <div class="col-2" (clickOutside)="onClickedOutside($event)" [autoClose]="'outside'"
                [ngbPopover]="popContent1" triggers="manual" #p1="ngbPopover" (click)="openPopover(p1)"
                placement="bottom" popoverClass='starttime-popover'>
                <input type="text" class="textbox-style pl-3 pointer-link" placeholder="Start Time"
                  [(ngModel)]="startTimePlaceholder">
                <img src="../../../assets/images/Path.png" class="dropdown-icon time-arrow" loading="lazy" />
                <ng-template #popContent1>
                  <div class="rectangle-copy-5">
                    <label class="start-time pl-4 pt-3">Start Time</label>
                    <div class="pl-3 pr-4 pt-1 ">
                      <ngb-timepicker [(ngModel)]="startTime" [meridian]="meridian"
                        (ngModelChange)="onTimeChange($event)" [minuteStep]="15"></ngb-timepicker>
                      <div>
                        <span class="hh-margin">hh</span>
                        <span class="mm-margin">mm</span>
                      </div>
                      <div class="toggle-position">
                        <label class="switch">
                          <input #saveamorpmCheckBox type="checkbox" id="saveamorpmCheckBox" [checked]="amorpm"
                            (change)="toggleAmPmSelection(saveamorpmCheckBox.checked)">
                          <span class="bookslider"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </div>

              <div class="col-2" (clickOutside)="onClickedOutside($event)" [autoClose]="'outside'"
                [ngbPopover]="popContent2" triggers="manual" #p2="ngbPopover" (click)="openPopover(p2)"
                placement="bottom" popoverClass='starttime-popover'>
                <input type="text" class="textbox-style pl-3 pointer-link" placeholder="End Time"
                  [(ngModel)]="endTimePlaceholder">
                <img src="../../../assets/images/Path.png" class="dropdown-icon time-arrow" loading="lazy" />
                <ng-template #popContent2>
                  <div class="rectangle-copy-5">
                    <label class="start-time pl-4 pt-3">End Time</label>
                    <div class="pl-3 pr-4 pt-1 ">
                      <ngb-timepicker [(ngModel)]="endTime" [meridian]="meridian"
                        (ngModelChange)="onTimeChange1($event)" [minuteStep]="15"></ngb-timepicker>
                      <div>
                        <span class="hh-margin">hh</span>
                        <span class="mm-margin">mm</span>
                      </div>
                      <div class="toggle-position">
                        <label class="switch">
                          <input #saveamorpmCheckBox type="checkbox" id="saveamorpmCheckBox" [checked]="amorpm1"
                            (change)="toggleAmPmSelection1(saveamorpmCheckBox.checked)">
                          <span class="bookslider"></span>
                        </label>
                      </div>

                    </div>
                  </div>
                </ng-template>
              </div>
              <div class="col-4"></div>
            </div>

            <div class="row">
              <div class="col-7">
                <p class="blue-text  mt-2">*Visitors are allowed in the park only between 7 am - 7 pm.</p>
              </div>
              <div class="col-5"></div>
            </div>

            <div class="row mt-2">
              <div class="col-4">
                <div class="dropdown-border pointer-link" style="position: relative;">
                  <div (clickOutside)="onClickedOutside($event)" [autoClose]="'outside'"
                    [ngbPopover]="popContentBuildingName" triggers="manual" #p="ngbPopover"
                    (click)="openPopover(p);enterName('buildingName')" placement="bottom"
                    popoverClass='dash-popover dashboard-popover'>
                    <input class="pt-3 pb-3 pl-4 textbox-style placeholder-text pointer-link"
                      [placeholder]="!buildingName ? 'Building Name' : ''" name="building" #building=ngModel readonly
                      [(ngModel)]="buildingTitle" required>
                    <label *ngIf="buildingName" class="form-lable-dropdown">Building Name</label>

                    <img src="../../../assets/images/Path.png" class="dropdown-icon" loading="lazy" />
                    <div *ngIf="building.invalid && (building.dirty || building.touched ||showError)"
                      class="field-error pl-2">
                      <span *ngIf="building.errors?.required">* This field is mandatory</span>
                    </div>
                  </div>
                </div>

                <ng-template #popContentBuildingName>
                  <div class="dashboard-popover">
                    <div class="d-flex justify-content-between">
                      <div class="pl-3 pt-3 pr-3 pb-3 ">
                        <div class="row pb-2" *ngFor="let item of buildingProperty;let index =i"
                          (click)="setBuildingName(item); openPopover(p)">
                          <div class="popover-content normal-font pl-3 email-width">
                            {{item.buildingName}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </div>

              <div class="col-4">
                <div class="dropdown-border pointer-link" style="position: relative;">
                  <div (clickOutside)="onClickedOutside($event)" [autoClose]="'outside'" [ngbPopover]="popFloorContent"
                    triggers="manual" #pf="ngbPopover" (click)="openPopover(pf);enterName('floor')" placement="bottom"
                    popoverClass='dash-popover dashboard-popover'>
                    <input class="pt-3 pb-3 pl-4 textbox-style placeholder-text pointer-link"
                      [placeholder]="!floor ? 'Floor (Optional)' : ''" readonly [(ngModel)]="floorTitle">
                    <label *ngIf="floor" class="form-lable-dropdown">Floor</label>
                    <img src="../../../assets/images/Path.png" class="dropdown-icon" loading="lazy" />
                  </div>
                </div>

                <ng-template #popFloorContent>
                  <div class="dashboard-popover">
                    <div class="d-flex justify-content-between">
                      <div class="pl-3 pt-3 pr-3 pb-3 ">
                        <div class="row pb-2" *ngFor="let item of floorList;let index =i"
                          (click)="setFloor(item); openPopover(pf)">
                          <div class="popover-content normal-font pl-3 email-width">
                            {{item}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </div>
            </div>
          </form>

          <div class="row mt-4" *ngIf="tableHeaders.length > 0">
            <div class="col-12 guest-count">{{tableBody.length}} Guests</div>
          </div>

          <div class="row">
            <div class="col-12 scroll">
              <table class="table table-borderless table-striped table-curved mt-4" id="pdfTable" #pdfTable
                *ngIf="tableHeaders.length > 0">
                <thead>
                  <tr>
                    <th class="check-container">
                      <label class="check-container">
                        <input type="checkbox" [checked]="selectAll" [value]="selectAll" [(ngModel)]="selectAll"
                          (change)="selectAllHandler()">
                        <span class="checkmark"></span>
                      </label>
                    </th>
                    <th *ngFor="let th of tableHeaders" scope="col">{{th}}</th>
                    <th></th>
                    <th>
                      <i class="fa fa-2x fa-trash" aria-hidden="true" (click)="deleteAllInvites()"
                        [ngClass]="{'disabledClick':!selectAll}"></i>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let td of tableBody; let i = index" [id]="generateUniqueId(i,'tr')">
                    <td class="check-container">
                      <label class="check-container">
                        <input type="checkbox" [checked]="selectAll" [value]="selectAll" (change)="selectedGuest(td, i)"
                          [id]="generateUniqueId(i,'th')" />
                        <span class="checkmark"></span>
                      </label>
                    </td>
                    <td *ngFor="let cell of td">
                      <span [ngClass]="generateUniqueId(i,'td')" style="display: block;">{{cell}}</span>
                      <input type="text" [ngClass]="generateUniqueId(i,'input')" style="display: none;" [value]="cell"
                        class="edit-input" />
                    </td>
                    <td><i class="fa fa-2x fa-pencil" aria-hidden="true" [ngClass]="checkIfSelected(i+'__th')"
                        (click)="editSelected(i+'__td', i+'__input', i, 'edit')" [id]="generateUniqueId(i,'edit')"
                        style="display: block;"></i>
                      <span [id]="generateUniqueId(i,'save')" style="display: none;"
                        (click)="editSelected(i+'__td', i+'__input', i, 'save')" class="save-btn">Save</span>
                    </td>
                    <td>
                      <i class="fa fa-2x fa-trash" aria-hidden="true" [ngClass]="checkIfSelected(i+'__th')"
                        (click)="deleteSelected(td,i)"></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-2"></div>
          </div>
        </div>
      </div>


      <div class="row footer-layout " *ngIf="tableHeaders.length > 0">

        <div class=" col-7">
          <p class="footer-text">{{tableBody.length}} guests will receive invitation mail.</p>
        </div>
        <div class="col-2">
          <button class="button-cancel">Cancel</button>
        </div>
        <div class="col-3">
          <button class="button-resend" (click)="send(myForm)">Send to CapitalLand</button>
        </div>
      </div>

      <!-- <app-footer></app-footer> -->

    </div>
  </div>